import * as angular from "angular";
import { LegacyUrlService } from "./LegacyUrl";
import { SettingsService } from "./Settings";
import { playServiceApi } from "./api/app";
import { EventService } from "./Event";

export let playService = angular.module("play.service", [playServiceApi.name]);

playService.service("LegacyUrlService", LegacyUrlService);
playService.service("EventService", EventService);
playService.factory("SettingsService", SettingsService);
